export const contactContainer = {
    marginRight: '1.5px',
    lineHeight: '25px',
    display: 'inline-block',
    overflow: 'hidden',
    verticalAlign: 'middle',
};
export const websiteContainer = {
    display: 'inline-block',
    verticalAlign: 'middle',
};
//# sourceMappingURL=styles.js.map